export const experiences = [
  {
    dateSpan: '2024 - Now',
    titles: ['Software Engineer, Product'],
    company: 'Postilize',
    href: 'https://www.postilize.com/',
    description: 'Build AI-powered tools for law firms to engage in business outreach and manage client relationships.',
    skills: ['System Design', 'Software Testing'],
    technologies: ['JavaScript', 'React', 'Express', 'MongoDB'],
  },
  {
    dateSpan: '2023 - 2025',
    titles: ['Educator', 'Web Development Mentor'],
    company: 'Lighthouse Labs',
    href: 'https://www.lighthouselabs.ca/',
    description: 'Mentor 500+ students across modern web fundamentals: JS, Python, React, Next, Node, SQL, Git, testing.',
    skills: ['Web Development', 'Content Delivery'],
    technologies: ['JavaScript', 'React', 'Express', 'SQL', 'Git'],
  },
  {
    dateSpan: '2023',
    titles: ['Developer', 'Undergraduate Program Secretary'],
    company: 'York University',
    href: 'https://www.yorku.ca/science/chemistry/',
    description: 'Built internal automation tools for the Department of Chemistry.',
    skills: ['Scripting', 'Task Automation'],
    technologies: ['JavaScript', 'Python', 'Selenium'],
  },
  {
    dateSpan: '2021 - 2023',
    titles: ['Co-founder'],
    company: 'Heritude Inc.',
    href: 'https://yfile.news.yorku.ca/2020/04/29/startup-focused-on-supporting-indigenous-artisans-wins-pitch-competition-coveted-spot-in-bestlab/',
    description: 'Launched a consumer product line. Hit break-even in fourteen months.',
    skills: ['Startup', 'Business Management'],
    technologies: ['Shopify', 'Amazon FBA'],
  },
  {
    dateSpan: '2019 - 2022',
    titles: ['Lead Site Coordinator', 'Operations Coordinator', 'Finance Coordinator'],
    company: "Let's Talk Science",
    href: 'https://letstalkscience.ca/',
    description: 'Led a team of three.',
    skills: ['Leadership', 'Project Management', 'Documentation'],
    technologies: ['Google Suite', 'MailChimp'],
  },
];
